import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import List from 'components/common/List/List'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'

const OverviewSection = ({ list = [], title = '' }) =>
  <Fragment>
    <Title data-at-sku-section={ title }>{ title }</Title>
    <List data-at-sku-section-content={ title } rare>
      { list.map((item, index) => <div key={ index }>{ item }</div>) }
    </List>
  </Fragment>

OverviewSection.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string
}

export default OverviewSection

const Title = styled.h3`
  margin: 21px 0 0;
  color: ${Theme.colors.black};
  text-transform: uppercase;
  ${Mixin.font.GothamBold(14)}
`
